/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of AppBuilder
 */

import { IBasicTrackerContext } from 'com/didichuxing/tracker/context/IBasicTrackerContext';
import { IOmegaSDK, IAppSdkInfo } from 'com/didichuxing/tracker/plugin/app/IOmegaSDK';
import WKWebviewOmegaSDK from 'com/didichuxing/tracker/plugin/app/WKWebviewOmegaSDK';

export default abstract class AppUtil {

    /**
     * 当前在安卓或iOS环境里
     * @returns {boolean}
     */
    public static inEnv(): boolean {
        return !!(window as any).OmegaSDK || AppUtil.inWKWebview();
    }

    /**
     * 当前在iOS的WKWebview环境中。
     * @returns {boolean}
     */
    public static inWKWebview(): boolean {
        return (window as any).webkit
            && (window as any).webkit.messageHandlers
            && (window as any).webkit.messageHandlers.getInfo;
    }

    /**
     * 获取APP桥接omega SDK对象。
     * @returns {IOmegaSDK}
     */
    public static getOmegaSDK(): IOmegaSDK | undefined {
        const omegaSDK: IOmegaSDK = (window as any).OmegaSDK;
        if (omegaSDK) {
            return omegaSDK;
        } else if ((window as any).webkit && (window as any).webkit.messageHandlers
            && (window as any).webkit.messageHandlers.getInfo) { // ios下采用WKWebview
            return new WKWebviewOmegaSDK();
        }
        return undefined;
    }

    /**
     * 获取App中的omega id
     * @param {IBasicTrackerContext} context
     * @returns {Promise<string>}
     */
    public static fetchAppOmgId(context?: IBasicTrackerContext): Promise<string> {
        return new Promise<string>((resolve: (oid: string) => void): void => {
            const appOmegaSDK = AppUtil.getOmegaSDK();
            if (appOmegaSDK) {
                if (AppUtil.inWKWebview()) {
                    appOmegaSDK.getInfo((info: IAppSdkInfo): void => {
                        if (info && info.oid) {
                            resolve(info.oid);
                        }
                    });
                } else {
                    // resolve((JSON.parse(appOmegaSDK.getInfo()) as IAppSdkInfo).oid);
                    // 加入异常拦截发现部分场景oid端内获取异常
                    try {
                        const str = appOmegaSDK.getInfo();
                        if (str) {
                            const info: IAppSdkInfo = JSON.parse(str);
                            if (info && info.oid) {
                                resolve(info.oid);
                            }
                        }
                    } catch (error) {
                        // console.error(error);
                    }
                }
            }
        });
    }
}
